(function () {
  // Toys Hunter — slider hero: frecce, pallini, scroll col dito, video che finiscono, audio.
  // Caricato con defer: i video non hanno autoplay, li avvia questo script.
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Il video "giusto" di una slide e' quello che il CSS lascia visibile:
  // desktop o telefono. L'altro resta fermo e non scarica niente.
  function visibleVideo(slide) {
    var vids = slide.querySelectorAll('.th-hero__video');
    for (var i = 0; i < vids.length; i++) {
      if (getComputedStyle(vids[i]).display !== 'none') return vids[i];
    }
    return null;
  }

  function pauseAll(root) {
    var vids = root.querySelectorAll('.th-hero__video');
    for (var i = 0; i < vids.length; i++) { vids[i].pause(); }
  }

  function init(root) {
    if (root.dataset.thHeroReady) return;
    root.dataset.thHeroReady = '1';

    var track = root.querySelector('[data-th-hero-track]');
    if (!track) return;
    var slides = track.children;
    var many = slides.length > 1;

    var dotsWrap = root.querySelector('[data-th-hero-dots]');
    var soundBtn = root.querySelector('[data-th-hero-sound]');
    var dotLabel = (dotsWrap && dotsWrap.dataset.dotLabel) || 'Slide';
    var delay = parseInt(root.dataset.autoplay, 10) || 0;
    var index = 0;
    var timer = null;
    var hovering = false;
    var soundOn = false;
    var current = null;
    var dots = [];
    var viewport = root.querySelector('.th-hero__viewport');

    function clearTimer() { if (timer) { clearTimeout(timer); timer = null; } }

    // Le slide con video passano alla successiva quando il video finisce,
    // non dopo un tempo fisso: un filmato da dieci secondi con un timer da
    // sei veniva tagliato. Le slide con la sola foto usano il timer.
    function schedule() {
      clearTimer();
      if (!many || delay <= 0 || hovering) return;
      if (current && !reduceMotion) return;
      timer = setTimeout(function () { show(index + 1); }, delay);
    }

    function onEnded() {
      if (!many) return;
      if (hovering || delay <= 0) {
        this.currentTime = 0;
        var p = this.play(); if (p && p.catch) p.catch(function () {});
        return;
      }
      show(index + 1);
    }

    // Il file del video sta in `data-src`: lo si assegna solo quando serve.
    function loadVideo(v) {
      if (!v || !v.dataset.src || v.getAttribute('src')) return;
      v.preload = 'auto';
      v.src = v.dataset.src;
    }

    function setLoading(slide, on) {
      if (slide) slide.classList.toggle('is-loading', on);
    }

    // I video si scaricano solo dopo il primo disegno della pagina (l'LCP
    // resta il poster) e solo con lo slider a schermo.
    var started = false;
    var inView = true;

    function playCurrent() {
      pauseAll(root);
      for (var i = 0; i < slides.length; i++) setLoading(slides[i], false);
      var slide = slides[index];
      var v = visibleVideo(slide);
      current = reduceMotion ? null : v;
      if (soundBtn) { soundBtn.hidden = !v; }
      if (!current || !started || !inView) return;
      loadVideo(current);
      current.muted = !soundOn;
      if (current.readyState < 3) setLoading(slide, true);
      if (current.currentTime) current.currentTime = 0;
      var p = current.play();
      if (p && p.catch) {
        p.catch(function (err) {
          // Interrotto perche' si e' cambiata slide: niente da fare.
          if (v !== current || (err && err.name === 'AbortError')) return;
          // Se il browser blocca la riproduzione (risparmio energetico,
          // audio non consentito) la slide non deve restare ferma.
          if (soundOn) { soundOn = false; updateSound(); v.muted = true; v.play().catch(function () {}); }
          else { setLoading(slide, false); current = null; schedule(); }
        });
      }
    }

    // Partito il video a schermo, si prepara quello della slide dopo, cosi
    // all'arrivo e' gia pronto. Gli altri restano non scaricati.
    function preloadNext() {
      if (many) loadVideo(visibleVideo(slides[(index + 1) % slides.length]));
    }

    // Pallini, video e timer seguono la slide `index`, senza spostare niente.
    function activate() {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
        dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
      }
      playCurrent();
      schedule();
    }

    // Il nastro scorre col suo scroll nativo (aggancio CSS): frecce, pallini
    // e scorrimento automatico ci arrivano con scrollTo.
    var target = 0;
    var targetUntil = 0;
    function show(n, instant) {
      index = (n + slides.length) % slides.length;
      if (viewport) {
        var smooth = !instant && !reduceMotion;
        target = index * viewport.clientWidth;
        targetUntil = smooth ? Date.now() + 1500 : 0;
        viewport.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
      }
      activate();
    }

    function updateSound() {
      if (!soundBtn) return;
      soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      soundBtn.setAttribute('aria-label', soundOn ? soundBtn.dataset.labelOff : soundBtn.dataset.labelOn);
      soundBtn.classList.toggle('is-on', soundOn);
    }

    var allVids = root.querySelectorAll('.th-hero__video');
    function slideOf(v) { return v.closest('.th-hero__slide'); }
    for (var v = 0; v < allVids.length; v++) {
      allVids[v].addEventListener('ended', onEnded);
      allVids[v].addEventListener('playing', function () {
        setLoading(slideOf(this), false);
        if (this === current) preloadNext();
      });
      allVids[v].addEventListener('waiting', function () {
        if (this === current) setLoading(slideOf(this), true);
      });
      // Un video che non si carica non arrivera mai a `ended`: la slide
      // ripiega sul timer invece di restare ferma per sempre.
      allVids[v].addEventListener('error', function () {
        setLoading(slideOf(this), false);
        if (this === current) { current = null; schedule(); }
      }, true);
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        soundOn = !soundOn;
        updateSound();
        if (current) { current.muted = !soundOn; if (current.paused) current.play().catch(function () {}); }
      });
    }

    if (many && dotsWrap) {
      for (var i = 0; i < slides.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'th-hero__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', dotLabel + ' ' + (i + 1));
        (function (n) { dot.addEventListener('click', function () { show(n); }); })(i);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    var prev = root.querySelector('[data-th-hero-prev]');
    var next = root.querySelector('[data-th-hero-next]');
    if (prev) { prev.addEventListener('click', function () { show(index - 1); }); }
    if (next) { next.addEventListener('click', function () { show(index + 1); }); }

    // Col dito scorre il browser e aggancia la slide da solo: qui si legge
    // dove si e' fermato. Durante uno scrollTo nostro si aspetta l'arrivo,
    // altrimenti a meta corsa si attivava una slide intermedia.
    var settle = null;
    if (many && viewport) {
      viewport.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var w = viewport.clientWidth || 1;
          if (Date.now() < targetUntil && Math.abs(viewport.scrollLeft - target) > 2) return;
          targetUntil = 0;
          var n = Math.round(viewport.scrollLeft / w);
          if (n !== index && n >= 0 && n < slides.length) { index = n; activate(); }
        }, 120);
      }, { passive: true });
      // Al primo tocco vince il dito: niente scrollTo che lo insegue.
      viewport.addEventListener('touchstart', function () { targetUntil = 0; clearTimer(); }, { passive: true });
      viewport.addEventListener('touchend', function () { schedule(); }, { passive: true });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(index - 1); }
      if (e.key === 'ArrowRight') { show(index + 1); }
    });

    // Pausa al passaggio del mouse solo dove il mouse c'e': su iPhone il tocco
    // genera un mouseenter senza mouseleave e fermava lo slider per sempre.
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseenter', function () { hovering = true; clearTimer(); });
      root.addEventListener('mouseleave', function () { hovering = false; schedule(); });
    }

    // Girando il telefono cambia la larghezza: la slide resta agganciata.
    // Su iPhone `resize` scatta anche quando la barra degli indirizzi si
    // apre o chiude: conta solo se e' cambiata la larghezza.
    var lastW = viewport ? viewport.clientWidth : 0;
    window.addEventListener('resize', function () {
      if (!viewport || viewport.clientWidth === lastW) return;
      lastW = viewport.clientWidth;
      viewport.scrollLeft = index * lastW;
    });

    // Il passaggio desktop/telefono cambia quale video e' visibile.
    var mq = window.matchMedia('(min-width: 768px)');
    if (mq.addEventListener) { mq.addEventListener('change', function () { playCurrent(); schedule(); }); }

    show(0, true);

    // Fuori schermo il video si ferma e non scarica: su telefono lo slider
    // esce di vista appena si scorre la pagina.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var vis = entries[entries.length - 1].isIntersecting;
        if (vis === inView) return;
        inView = vis;
        if (inView) { playCurrent(); schedule(); }
        else { pauseAll(root); }
      }).observe(root);
    }

    // Primo video dopo il caricamento della pagina, quando il browser e'
    // libero: il poster e' gia a schermo e fa da LCP.
    function start() {
      if (started) return;
      started = true;
      playCurrent();
      schedule();
    }
    function startIdle() {
      if (window.requestIdleCallback) requestIdleCallback(start, { timeout: 2000 });
      else setTimeout(start, 200);
    }
    if (document.readyState === 'complete') startIdle();
    else window.addEventListener('load', startIdle);
  }

  function run() {
    var nodes = document.querySelectorAll('[data-th-hero]');
    for (var i = 0; i < nodes.length; i++) { init(nodes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
